/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Required_ShortInputs */

const en_validation_required_short = /** @type {(inputs: Validation_Required_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

const de_validation_required_short = /** @type {(inputs: Validation_Required_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pflichtfeld`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Validation_Required_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_required_short = /** @type {((inputs?: Validation_Required_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Required_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_required_short(inputs)
	return en_validation_required_short(inputs)
});